export const version = 'kunde-v1.20.0-SNAPSHOT-7bb2ed2d9e15c371cff65394dd848f16db0211a5';